import {environment} from '../../../environments/environment';

export class HarPage {
    id: string;
    url: string;
    title: string;
    startedTime: Date;

    constructor(startDate: Date) {
      this.id = 'app';
      this.url = environment.frontendUrl;
      this.title = 'Global Office Data Hub';
      this.startedTime = startDate;
    }
}
